import styled from 'styled-components';
import { ChatBodyProps } from '.';
import { DEVICE } from '../../GlobalStyle';

export const Container = styled.div<{styles: ChatBodyProps, isExpanded: boolean}>`
  background-color: ${props => props.styles.backgroundColor};
  height: 300px;
  overflow-y: scroll;

  @media ${DEVICE.mobile} {
    height: calc(100vh - 90px - 50px);
    height: calc(100 * var(--vh) - 90px - 50px);
  }

  ${props => props.isExpanded ? `
    height: calc(100vh - 90px - 50px);
    height: calc(100 * var(--vh) - 90px - 50px);
  `
  :
  ``
  }
`;

export const MessagesContainer = styled.div`
  flex: 0 0 auto;
  padding-bottom: 8px;
  padding-top: 5px;
  transition: padding-left .3s cubic-bezier(.69,0,.79,.14);
`;

export const LoadingContainer = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  margin: auto;
  margin-top: 25px;
  margin-bottom: 40px;
  box-shadow: #6e6e63;
  background-color: #fff;
  display: flex;
`;